<template>
  <v-main tag="form" class="page-account">
    <AppBar/>
    <v-layout fill-height column>
      <v-container flex-fill fluid>
        <div class="account-title-block">
          <h3 class="tit" v-if="division==='02'">
            <span class="tit-point">회원</span> 정보 입력
          </h3>
          <h3 class="tit" v-if="division==='01'">
            <span class="tit-point">기업회원</span> 정보입력
          </h3>
          <p class="desc">
            계정을 생성해 주세요.
          </p>
        </div>
        <v-form class="form-item" ref="idForm" lazy-validation>
          <label class="label">아이디 <span class="text--required">*</span></label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="userId" :rules="id_rules" ref="userId" required autocomplete="off"
                          placeholder="아이디 입력" maxlength="20"
                          v-bind:readonly="getClientCd()"
                          oninput="javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' );"/>
            <v-btn v-if="!getClientCd()"
                   depressed :ripple="false" color="primary" class="btn-input" width="90"
                   @click="getUserReduUserId">중복검사
            </v-btn>
          </div>
          <div class="px-3 mt-n2">
            <span class="lightBlue--text fs-12" v-if="idDuplChk && idCheck === 0 && !getClientCd()">사용가능한 아이디입니다.</span>
            <span class="error--text fs-12" v-else-if="idDuplChkMsg && !getClientCd()">중복 검사를 진행해주세요.</span>
            <span class="error--text fs-12" v-else-if="idCheck > 0 && !getClientCd()">중복된 아이디가 있습니다.</span>
          </div>
          <div style="height: 20px;"></div>
        </v-form>
        <v-form class="form-item" ref="form" lazy-validation>
          <label v-if="this.$store.getters.userKey!==''" class="label">
            새 비밀번호 <span class="text--required">*</span>
          </label>
          <label v-else class="label">
            비밀번호 <span class="text--required">*</span>
          </label>
          <div class="input-group">
            <v-text-field type="password" solo flat filled v-model="password" :rules="password_rule" required autocomplete="off"
                          placeholder="8~20자 영문, 숫자, 특수문자"/>
          </div>

          <label v-if="this.$store.getters.userKey!==''" class="label">
            새 비밀번호 재입력
          </label>
          <label v-else class="label">
            비밀번호 확인 <span class="text--required">*</span>
          </label>
          <div class="input-group">
            <v-text-field type="password" solo flat filled v-model="checkPassword" :rules="chPassword_rule" autocomplete="off"
                          required placeholder="비밀번호 재입력"/>
          </div>

          <label class="label">이메일 <span class="text--required">*</span></label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="email" :rules="email_rule && !emailReadOnly" id="email" required autocomplete="off" :readonly="emailReadOnly"
                          placeholder="welcome@eznwell.co.kr"/>
          </div>
        </v-form>
        <v-form class="form-item" ref="nickForm" lazy-validation>
          <label class="label">닉네임 <span class="text--required">*</span></label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="nickname" ref="nickname" :rules="nickname_rule" autocomplete="off"
                          required placeholder="한글, 영문, 숫자 혼용하여 10자이내"/>
            <v-btn depressed :ripple="false" color="primary" class="btn-input" width="90"
                   @click="getUserReduNicknameInner">중복검사
            </v-btn>
          </div>
          <div class="px-3 mt-n2">
            <span class="lightBlue--text fs-12" v-if="nickDuplChk && nickCheck === 0">사용가능한 닉네임입니다.</span>
            <span class="error--text fs-12" v-else-if="nickDuplChkMsg">중복 검사를 진행해주세요.</span>
            <span class="error--text fs-12" v-else-if="nickCheck > 0">중복된 닉네임이 있습니다.</span>
          </div>
        </v-form>
      </v-container>
      <v-footer grow color="transparent" class="content-footer">
        <div class="content-buttons">
          <BlackBtn x-large str="다음" :disabled="nextDisabled" @click="setJoin"/>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>
<script>
import store from "@/store";
import { mixinReward } from '@/mixins'
import BlackBtn from "@/components/btns/BlackBtn";

export default {
  components: {
    BlackBtn,
  },
  mixins: [ mixinReward ],
  data: () => ({
    idDuplChk: false	//아이디 중복검사 실행여부
    , idDuplChkMsg: false	//아이디 중복검사 메세지 노출여부(처음에 비노출 다음버튼때 노출해야하여 따로 상태값 존재)
    , idCheck: -1			//아이디 중복갯수 -1초기값, 0:중복없음

    , nickDuplChk: false	//닉네임 중복검사 실행여부
    , nickDuplChkMsg: false	//닉네임 중복검사 메세지 노출여부(처음에 비노출 다음버튼때 노출해야하여 따로 상태값 존재)
    , nickCheck: -1			//닉네임 중복갯수 -1초기값, 0:중복없음
    , nextDisabled: true // 다음버튼 활성화 flag

    , clientNo: null

    , userId: ''
    , email: ""
    , password: ""
    , checkPassword: ""
    , nickname: ''
    , emailReadOnly: false
  }),

  computed: {
    trialUser () {
      return this.joinUser.trialUser
    },
    joinUser () {
      return store.state.memberJoin.joinUser
    },
    division () {
      return store.state.memberJoin.joinUser.division
    },
    email_rule() {
      return [
        v => !!v || '필수 입력사항입니다.',
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || '메일 형식이 잘못 되었습니다.'
      ];
    },
    password_rule() {
      return [
        v => !!v || '필수 입력사항입니다.',
        v => !(v && v.length <= 7) || '8자 이상 입력해주세요.',
        v => !!(v && /\d/.test(v)) || '숫자를 포함하여 입력해주세요.',
        v => !!(v && /[A-Za-z]/.test(v)) || '문자를 포함하여 입력해주세요.',
        v => !!(v && /[^A-Za-z0-9]/.test(v)) || '특수문자를 포함하여 입력해주세요.',
      ];
    },
    chPassword_rule() {
      return [
        v => this.chkValidPasswd(v)
      ];
    },
    nickname_rule() {
      return [
        v => !!v || '필수 입력사항입니다.',
        v => /^[a-zA-Zㄱ-힣0-9]*$/.test(v) || '한글, 영문, 숫자만 (특수문자 제외) 입력 가능합니다.',
        v => !(v && v.length > 10) || '10자 이내로 입력 가능합니다.'
      ]
    },
    id_rules() {
      return [
        v => !!v || '아이디는 필수 입력사항입니다.',
        v => /^[a-zA-Z0-9-_.]*$/.test(v) || '아이디는 영문/숫자/특수문자(-),(_),(.) 입력 가능합니다.',
        v => !(v && v.length < 2) || '아이디는 2자 이상 입력해야합니다.',
        v => !(v && v.length >= 20) || '아이디는 20자 이상 입력할 수 없습니다.',
      ]
    },
  },
  watch: {
    userId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.idDuplChkMsg = false
        this.idDuplChk = false
        this.idCheck = -1
      }
      this.nextValidVerify()
    },
    password() {
      this.nextValidVerify()
    },
    checkPassword() {
      this.nextValidVerify()
    },
    email() {
      this.nextValidVerify()
    },
    nickname: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.nickDuplChkMsg = false
        this.nickDuplChk = false
        this.nickCheck = -1
      }
      this.nextValidVerify()
    },
  },
  mounted() {
    if (this.trialUser) {
      this.email = this.joinUser.email
      this.emailReadOnly = true
    }

    //명부형일때 로그인정보에서 가져옴, 무명부형은 티켓입력화면에서 clientNo로 넘어옴
    if (this.getClientCd()) {
      this.userId = store.getters.userId
      this.clientNo = store.getters.clientCd
    } else {

      // 무명부형
      this.clientNo = this.joinUser.clientNo;

      // 일반회원
      if ((this.clientNo == "" || this.clientNo == undefined) && this.division === "02") {
        this.clientNo = "b2c"
      }
    }

    //division 유실된경우 새로고침등 로그인 페이지로 보냄
    if (this.division == "" || this.division == undefined) {
      window.location.href = '/user/login'
    }
  },
  methods: {
    nextValidVerify() {

      if (this.userId.trim() != '' && this.password.trim() != '' && this.checkPassword.trim() != ''
        && this.email.trim() != '' && this.nickname.trim() != '') {

        this.nextDisabled = false
      }else{
        this.nextDisabled = true
      }
    },

    chkValidPasswd() {
      if (this.checkPassword !== this.password) {
        return '패스워드가 일치하지 않습니다.'
      }
      return true
    },
    getClientCd() {
      let clientCd = this.$store.state.auth.authUser.clientCd;
      return clientCd !== undefined;
    },
    inputNickname() {
      this.nickCheck = -1;
    },
    async getUserReduNicknameInner() {

      let validateNick = this.$refs.nickForm.validate()

      if (validateNick) {
        // 통과
        // this.nickDuplChkMsg = false
        // this.nickDuplChk = true
        // this.nickCheck = 0

        // 중복존재
        // this.nickDuplChkMsg = false
        // this.nickDuplChk = true
        // this.nickCheck = 1

        await store.dispatch('getUserReduNicknameInner', this.$_payload({'nickname': this.nickname}))
          .then(res => {
            if (res.success) {
              this.nickCheck = res.data;

              if (this.nickCheck > 0) {
                // 중복존재
                this.nickDuplChkMsg = false
                this.nickDuplChk = true
                this.nickCheck = 1
              } else {
                // 통과
                this.nickDuplChkMsg = false
                this.nickDuplChk = true
                this.nickCheck = 0
              }

            } else {
              console.log(res.msg);
              this.nickname.focus()
            }
          })
          .catch(error => {
            console.error(error);
            this.nickname.focus();
          })
          .finally(() => {
          });
      }
    },

    async getUserReduUserId() {
      let validateId = this.$refs.idForm.validate()
      if (validateId) {
        // 통과
        // this.idDuplChkMsg = false
        // this.idDuplChk = true
        // this.idCheck = 0

        // 중복존재
        // this.idDuplChkMsg = false
        // this.idDuplChk = true
        // this.idCheck = 1

        await store.dispatch('getUserReduUseridInner', this.$_payload({
          'userId': this.userId,
          'clientNo': this.clientNo
        }))
          .then(res => {
            if (res.success) {
              this.idCheck = res.data;

              if (this.idCheck > 0) {
                // 중복존재
                this.idDuplChkMsg = false
                this.idDuplChk = true
                this.idCheck = 1
              } else {
                // 통과
                this.idDuplChkMsg = false
                this.idDuplChk = true
                this.idCheck = 0
              }

            } else {
              console.log(res.msg);
              this.userId.focus();
            }
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
          })
      }
    },


    async setJoin() {

      // id rules 통과여부
      let validateId = this.$refs.idForm.validate()

      // 비밀번호 이메일 rules 통과여부
      let validate = this.$refs.form.validate()

      let validateNick = this.$refs.nickForm.validate()

      if (validateId && validate && validateNick) {	// 모든 입력값에 rules 통과될때

        if (!this.idDuplChk && !this.getClientCd()) {	// 명부형은 제외
          this.idDuplChkMsg = true	// id 중복검사 실행 문구
        } else if (!this.nickDuplChk) {
          this.nickDuplChkMsg = true	// 닉네임 중복검사 실행 문구

        } else if (this.idDuplChk && this.idCheck > 0) {	// id 중복검사후 중복존재
          // console.log('id 중복 존재')
        } else if (this.nickDuplChk && this.nickCheck > 0) {	//닉네임 중복검사후 중복존재
          // console.log('닉네임 중복 존재')
        } else {
          // console.log('회원정보 등록')
          //01 기업회원(무/명부형), 02 일반회원
          if(this.joinUser.division==="02") this.clientNo = "b2c";	// 페이지 진입시 부여

          // TODO 회원정보 store에 저장
          let setData = {
            userId: this.userId,
            email: this.email,
            password: this.password,
            nickname: this.nickname,
            clientNo: this.clientNo
          }
          store.commit('setJoinUser', setData)

          if (this.division === "01" && store.getters.userKey !== "") { //기업회원 명부형 정보 갱신
            await store.dispatch('setMemberInfo', this.$_payload('inData', { userKey: store.getters.userKey, ...this.joinUser }))
                .then(res => {
                  if (res.success) {
                    store.commit('initJoinUser')
                    if (this.clientNo !== 'samsungfire') { // 삼성화재는 코인발급 x
                      this.insertMemberCoin(store.getters.userKey, 10, '0001')
                      // this.$root.$children[0].$refs.content.$emit('insertMemberCoin', store.getters.userKey, 10, '0001')
                    }
                    this.$router.push({name: "회원가입 완료"});
                  }
                }).catch(error => {
                  console.error(error);
                }).finally(() => {

                })

          } else if ((this.division === "01" && store.getters.userKey === "") ||
              (this.division === "02" && store.getters.userKey === "")) { // 기업회원 무명부형, 일반회원 가입 처리.
            await store.dispatch('setJoinRegistration', this.$_payload('memberJoinPo', this.joinUser))
                .then(res => {
                  if (res.success && res.data > 0) {
                    store.commit('initJoinUser')
                    let userKey = res.data;
                    if (this.clientNo !== 'samsungfire') { // 삼성화재는 코인발급 x
                      this.insertMemberCoin(userKey, 10, '0001')
                      // this.$root.$children[0].$refs.content.$emit('insertMemberCoin', userKey, 10, '0001')
                    }
                    this.$router.push({name: "회원가입 완료"});
                  } else {
                    console.log("res : ", res)
                    this.$alert('회원가입에 실패하였습니다. 관리자에게 문의해주세요.')
                  }
                }).catch(error => {
                  console.error(error);
                }).finally(() => {
                })
          }
        }
      }

    }
  }
};
</script>
<style lang="scss" scoped>
.lightBlue--text {
  color: blue;
}

::v-deep.v-input--radio-group {
  margin-top: 0;
  padding-top: 0;
  flex: 1 1 auto !important;

  .v-input--radio-group__input {
    gap: 14px;
  }

  .radio {
    flex: 1;

    .v-input--selection-controls__input {
      display: none;
    }

    .v-label {
      height: 48px;
      border: 1px solid #D9D9D9;
      border-radius: 10px;
      color: #212529;
      justify-content: center;
    }

    &.active {
      .v-label {
        background: #000;
        color: #fff;
      }
    }
  }
}
</style>
